import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Bus, Info, Wallet } from 'lucide-react';

export const DayTimeline = ({ day, dayNumber }) => {
  return (
    <Card className="border-0 shadow-card rounded-card bg-white overflow-hidden">
      <div className="h-1.5 bg-primary" />
      <CardHeader>
        <CardTitle className="text-lg text-text-primary flex items-center gap-2">
          <span className="w-8 h-8 rounded-full bg-primary flex items-center justify-center text-white text-sm font-bold">
            {dayNumber}
          </span>
          {day.title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="relative">
          <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-[#E8E4DF]" />
          <div className="space-y-5">
            {day.activities?.map((item, idx) => (
              <div key={idx} className="relative pl-10">
                <div className="absolute left-2.5 top-2 w-3 h-3 rounded-full bg-primary border-2 border-white shadow-sm" />
                <div className="bg-bg-secondary rounded-card p-4 hover:bg-[#E8E4DF]/50 transition-colors">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="text-sm font-bold text-primary">{item.time}</span>
                    <h4 className="font-semibold text-text-primary">{item.spot}</h4>
                    <span className="text-xs text-text-secondary bg-white px-2 py-0.5 rounded-full border border-[#E8E4DF]">{item.duration}</span>
                    <span className="text-xs text-text-secondary">{item.type}</span>
                  </div>
                  <div className="flex flex-wrap gap-1.5 mb-2">
                    {item.tags?.map((tag, tIdx) => (
                      <span key={tIdx} className="text-[10px] px-2 py-0.5 rounded-full bg-primary-light text-primary font-medium">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-xs text-text-secondary">
                    {item.transport && (
                      <div className="flex items-center gap-1.5">
                        <Bus className="w-3.5 h-3.5 text-primary" />
                        <span>{item.transport}</span>
                      </div>
                    )}
                    {item.cost && (
                      <div className="flex items-center gap-1.5">
                        <Wallet className="w-3.5 h-3.5 text-primary" />
                        <span>{item.cost}</span>
                      </div>
                    )}
                    {item.tips && (
                      <div className="flex items-center gap-1.5">
                        <Info className="w-3.5 h-3.5 text-primary" />
                        <span>{item.tips}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
